export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=04d5884c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/faq/index.vue?vue&type=template&id=04d5884c&
// module id = 1362
// module chunks = 0